var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline"},[_c('v-btn',{attrs:{"aria-label":_vm.ariaLabel,"rounded":"","text":"","exact":""},on:{"click":function($event){$event.preventDefault();return _vm.go()}}},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }